import styled from 'styled-components'
import Box from 'components/shared/Box'
import { Wrapper as WarningWrapper } from 'routes/Upsell/CabanasCreator/fields/CabanaRequirementsWarning/styles'
import { respondAbove } from 'styles/mediaQueries'

export const Creator = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_100};

    ${WarningWrapper} {
        margin-top: 16px;
        padding-top: 12px;
        padding-bottom: 0;
        border-top: 2px solid ${({ theme }) => theme.colors.grayscale_300};

        @media ${respondAbove.xl} {
            margin-top: 40px;
            padding-top: 32px;
            padding-bottom: 8px;
        }
    }
`
